
/**
 * 数据透视表组件
 */

import React from 'react';
import { Card, Table, Switch, Space } from 'antd';
import type { TreeNode } from '../types';
import { useImportAction } from './hooks/useImportAction';
import { useTableColumns } from './hooks/useTableColumns';

interface DataTableProps {
    treeData: TreeNode[];
    showKeyword: boolean;
    showDate: boolean;
    showPriceRange: boolean;
    onShowKeywordChange: (value: boolean) => void;
    onShowDateChange: (value: boolean) => void;
    onShowPriceRangeChange: (value: boolean) => void;
    skuId?: number;
}

export const DataTable: React.FC<DataTableProps> = ({
    treeData,
    showKeyword,
    showDate,
    showPriceRange,
    onShowKeywordChange,
    onShowDateChange,
    onShowPriceRangeChange,
    skuId,
}) => {
    const { importLoading, handleImport } = useImportAction(skuId);
    const columns = useTableColumns({ skuId, importLoading, handleImport });

    return (
        <Card
            size="small"
            title="关键词分析透视表"
            extra={
                <Space size="middle">
                    <span>
                        <Switch size="small" checked={showKeyword} onChange={onShowKeywordChange} /> 关键词
                    </span>
                    <span>
                        <Switch size="small" checked={showDate} onChange={onShowDateChange} /> 日期
                    </span>
                    <span>
                        <Switch size="small" checked={showPriceRange} onChange={onShowPriceRangeChange} /> 价格区间
                    </span>
                </Space>
            }
        >
            <Table
                columns={columns}
                dataSource={treeData || []}
                rowKey="key"
                pagination={false}
                size="small"
                defaultExpandAllRows
                expandable={{ defaultExpandAllRows: true }}
                indentSize={20}
                scroll={{ x: 850 }}
            />
        </Card>
    );
};
